import { graphql } from "relay-runtime"

export const RequestedMedicationsFragment = graphql`
  fragment RequestedMedicationsFragment on Appointment {
    requestedMedications {
      name
      mainSubstance
      packageSize
      pharmaCode
      productUrl
    }
  }
`
